import {
  OUTFITS,
  OUTFIT,
  DELETE,
  SORT,
  MORE,
  LOADING,
  TOTAL,
} from './mutation-types';

export default {
  [OUTFITS](state, payload) {
    if (state.items.length > 0) {
      const items = [...state.items];
      const itemsIds = items.map(item => item.id);
      payload.forEach((item) => {
        const index = itemsIds.indexOf(item.id);
        if (index > -1) {
          items[index] = item;
        } else {
          items.push(item);
        }
      });
      state.items = items;
    } else {
      state.items = payload;
    }
  },
  [OUTFIT](state, payload) {
    state.items = state.items.map(item => (item.id === payload.id ? Object.assign({}, item, payload) : item));
  },
  [DELETE](state, payload) {
    if (Array.isArray(payload)) {
      state.items = state.items.filter(item => payload.indexOf(item.id) === -1);
    } else {
      state.items = state.items.filter(item => item.id !== payload);
    }
  },
  [SORT](state, payload) {
    state.sort = payload;
  },
  [MORE](state, payload) {
    state.more = payload;
  },
  [LOADING](state, payload) {
    state.loading = payload;
  },
  [TOTAL](state, payload) {
    state.total = payload;
  },
};
